import { render, staticRenderFns } from "./OwnerSettingIndex.vue?vue&type=template&id=1997331b&scoped=true"
import script from "./OwnerSettingIndex.vue?vue&type=script&lang=js"
export * from "./OwnerSettingIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1997331b",
  null
  
)

export default component.exports